module.exports = __webpack_public_path__ + "img/Ersa-VERSAFLOW345-01-900x675.119121f7.png";